import { PaymentSuccessContainer } from "../containers/PaymentSuccessContainer";

export const PaymentSuccessPage = () => <PaymentSuccessContainer />;
